import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { AppHeader, LeftPanel } from '../../components/layout';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      minHeight: '100vh',
    },
    contentWrapper: {
      display: 'flex',
      flexGrow: 1,
      paddingTop: theme.layout.topBarHeight, // fake header for sticky header
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      backgroundColor: theme.palette.alternate.main,
      // overflow: 'auto',
    },
  };
});

const BasicLayout = (props) => {
  const classes = useStyles();

  return (
    <div className={ classes.root }>
      <AppHeader />
      <LeftPanel />
      <main className={ classes.contentWrapper }>
        <Box className={ classes.content }>
          {props.children}
        </Box>
      </main>
    </div>
  );
};

export default BasicLayout;
